import { css } from '@emotion/core';
import { token } from '@atlaskit/tokens';

import { SPACE_COMPACT, flexStart, flex } from '@/styles';

export const requiredStyles = css`
  padding-left: 2px;
  color: ${token('color.text.danger')};
`;

export const helpStyles = css`
  margin-left: ${SPACE_COMPACT}px;
  div[role='presentation'] {
    ${flex}
  }
`;

// Since we are controlling required mark in this component now, hide the default one
export const hideDefaultRequiredIconStyles = css`
  & + span {
    display: none;
  }
`;

export const helpTooltipContainerStyles = [flexStart, hideDefaultRequiredIconStyles];
